// import Details from "../../components/Contents/Details";
import CommentStyle from "./comments.module.scss";

function Comment() {
  return (
    <>
      <div className={CommentStyle.comment}>
        <div className={CommentStyle.commentProfileUser}>
          <div className={CommentStyle.commentProfileUserPP}>
            <img
              src={`https://s3-alpha-sig.figma.com/img/6989/fa55/0b70f9e3dda2c46d3dbb67885145014e?Expires=1637539200&Signature=Mm9VNezDRtsO37Zg-lLvWn4K3td1WnkryOWxBei29AhDj2x3MgAchhAeGV6ik~-Qp7mWSISij-jcLWmphWBnlmosCFPtHpuZmViBQCp21Y-7pDSlbCPqZBYdz4s2hH8rxapxL2yjbpVbsCcqAfNyH6FzP3lWvG-E9bE2Gdvk-qgLE-DaR-3V3u3cUI2ZAYW4TqwFMW0gwOSyDEKoOgfBI7HA727lqZMSEcUt6HUiAjvkgB2GQd6W83D5YSD9TVRa0atZOv~JEJwGvIk6hWYWqAYrx6WIa1ZmPNEFlysi6Xe4VIX-QldNHVIEGidnall2Z-W3GE50kvrqFDQaps9mOQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA`}
              alt="John Doe"
            />
          </div>
          <div className={CommentStyle.commentProfileUserInfo}>
            <p>Yoshua Ginting</p>
            <p>4 Days ago</p>
          </div>
        </div>
        <p>Hi, do you have a youtube channel that I can subscribe?</p>
        <div className={CommentStyle.commentProfileUser}>
          <div className={CommentStyle.commentProfileUserPP}>
            <img
              src={`https://s3-alpha-sig.figma.com/img/0fd8/59ba/f2cc8b48344c3f8585fb7530dd3e3609?Expires=1638144000&Signature=PgBEFSAx9vDOCoaC9bnWQ4xUlQbyzE8MU690T8dcA6FUme-xJZBL9Ty4ybo76Lm3ENdsRPb4wtwNg2cJIme7NqxHypNg8zhuWxqxnxnf5riXVLI-G~-sg6acrPmPiVOcoqeO~uOrzlMjFc6Dpoh0Jxzoac2cDSoS1hQQ1OZRov-CNotQdKM22xbdtMhBMgkELHy3hkM7xutMEjJoxsPGfOeu640oODXONInVX9bE-jpGYs5uISAvBmJSHJQ6UrJy6snezBkX7jYiovWOlSEHQfjcBdeElcYvqYlWHiHZwK~xRHrA15D20LWgFHi5tvv9ZQOJF0IFlWRFLddxmsMVlg__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA`}
              alt="Yosua Ginting"
            />
          </div>
          <div className={CommentStyle.commentProfileUserInfo}>
            <p>Agnes Mo</p>
            <p>4 Hours ago</p>
          </div>
        </div>
        <p>Hi pratur! I like your event, I already sent you an email about my upcoming event, could you hosted my event?</p>
        <div className={CommentStyle.commentProfileUser}>
          <div className={CommentStyle.commentProfileUserPP}>
            <img
              src={`https://s3-alpha-sig.figma.com/img/0bd1/4e23/71a5ccbc3d1830e042fb195a85046580?Expires=1638144000&Signature=Nr6-Qetbv~ZGjvTn0O87PnAKvI2vzgGVluVivnBsZS9bZ4XsqnYilpTeyjT44wrhjs5QYcKA~u4nwxzGY~Oh5iHSec5ZKa7miKeB2zIPFWqrMzf0gM4EkDLpoO~qslJwj2r5M2-pXwD-L0YwCRRbn0mnMeMP2mD8RsCx4k3ZzO7RgROcDVwRcG-FXb~BW058AU3LGGN1WfzI3r2-xhM~EkxU6K5dT0mOU~iNkKkkh4PveON-7HIV6IdbKNMstU8bM3GxR6ZhG9eHNV~mWH-AoTMxbelLISH8J3rimH91H~62cKC3PAyLMN1fH1N92mX~Wy96MJnTBuluIahFYcXCIw__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA`}
              alt="Bambang Prakoso"
            />
          </div>
          <div className={CommentStyle.commentProfileUserInfo}>
            <p>Bambang Prakoso</p>
            <p>20 Minutes ago</p>
          </div>
        </div>
        <p>Good Event!</p>
        <div className={CommentStyle.commentProfileUser}>
          <div className={CommentStyle.commentProfileUserPP}>
            <img
              src={`https://s3-alpha-sig.figma.com/img/2a84/2041/24f7143e149b588ffaa3f84662432c78?Expires=1638144000&Signature=Oc3fuirpC8LE3NdnQiwwUeK8OLS8U0m2vFZtyJ8sA2uVj0MNv4STXMKctyMZKu39um4tbNY9rf9YKhecF0fx583E2WNOvCqo45Dc6aYFySY54dkGL4imhTqOemJ~a1fuwVGZCFufpFpnqU0sGi53J7bIVFIUJZqGkCd7O-~iTyKH9hoTrtxNF7B810r8xUIG9FMdmONUmUlgq9U1EGldXu7eeV3X7KUj5Xf6LJKzI96Y7HvH~4z61hBb7gJn~X18~A--NzbzddQAj93~Y3~XGmSBLwYtyzQWBo6m79Bq8VobRaENNThkLQ1SH8F3xKO7nMzuAaU6ltZ7VPwVZicgFg__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA`}
              alt="Fandy Araya"
            />
          </div>
          <div className={CommentStyle.commentProfileUserInfo}>
            <p>Fandy Araya</p>
            <p>20 Minutes ago</p>
          </div>
        </div>
        <p>Bravo!</p>
      </div>
    </>
  );
}
export default Comment;
